"use client";

import { useEffect } from "react";

export function PerformanceMonitor() {
  useEffect(() => {
    // Monitor Core Web Vitals
    if (typeof window !== "undefined" && "performance" in window) {
      // Largest Contentful Paint (LCP)
      const observer = new PerformanceObserver((list) => {
        for (const entry of list.getEntries()) {
          if (entry.entryType === "largest-contentful-paint") {
            // LCP measured but not logged
          }
        }
      });

      try {
        observer.observe({ entryTypes: ["largest-contentful-paint"] });
      } catch {
        // Fallback for browsers that don't support this
      }

      // First Input Delay (FID) and Cumulative Layout Shift (CLS)
      const webVitalsObserver = new PerformanceObserver((list) => {
        for (const entry of list.getEntries()) {
          if (entry.entryType === "first-input") {
            // FID measured but not logged
          }
          if (entry.entryType === "layout-shift") {
            // CLS measured but not logged
          }
        }
      });

      try {
        webVitalsObserver.observe({
          entryTypes: ["first-input", "layout-shift"],
        });
      } catch {
        // Fallback for browsers that don't support this
      }

      // Image loading performance
      const imageObserver = new PerformanceObserver((list) => {
        for (const entry of list.getEntries()) {
          if (entry.entryType === "resource") {
            // Image loading performance measured but not logged
          }
        }
      });

      try {
        imageObserver.observe({ entryTypes: ["resource"] });
      } catch {
        // Fallback for browsers that don't support this
      }

      return () => {
        observer.disconnect();
        webVitalsObserver.disconnect();
        imageObserver.disconnect();
      };
    }
  }, []);

  return null;
}
